/*
 * @Author: tongbin.xtb
 * @Date: 2018-11-07 13:32:04
 * @Last Modified by: tongbin.xtb
 * @Last Modified time: 2019-04-21 20:38:31
 */


import {
  proxyValueTree, proxyBehavior, proxyStateProps,
} from './setValue';
import proxyCreateContext from '../../createContext';
import Form from '../../../store/form';
import {
  proxyOwnerForm,
  defineFormSubmit,
  proxyFormAPI,
  getAndProxyForm,
} from '../proxyForm';
import proxyIndex from '../proxyIndex';
/* eslint-disable no-use-before-define */
export function proxyStateWithForm({
  ctx, state, form,
}) {
  if (!state.componentSchema && state.type === 'SCALAR' || (state.data === null)) {
    // 直接返回存储的数据
    return state.getValue();
  }
  const proxy = {};
  proxy.getInstance = () => ctx.getComponentInstance(state.getData('fieldId'), state.getIteratorId());
  if (state.getItems && state.getItems && state.getItems()) {
    Object.defineProperties(proxy, {
      items: {
        get() {
          return proxyCreateContext(ctx, state.getItems());
        },
      },
    });
  }
  if (state.owner) {
    Object.defineProperties(proxy, {
      parent: {
        get() {
          return proxyParent(ctx, state);
        },
      },
    });
    if (state.remove) {
      proxy.remove = state.remove.bind(state);
    }
  }
  // define properties
  proxyIndex(proxy, state);
  proxyStateAPI(proxy, state, form);
  if (isValidForm(form)) {
    defineFormSubmit(ctx, proxy, form);
    proxyFormAPI(proxy, form);
  }
  if (!proxy.hasOwnProperty('form')) {
    Object.defineProperty(proxy, 'form', {
      get() {
        return getAndProxyForm(state, ctx);
      },
    });
  }
  // 使用原型创建
  const result = Object.create(proxy);
  proxyStateProps(result, state, ctx);
  if (!('value' in result) && (isValidForm(form)
    || (
      state.getValue()
      && 'fieldData' in state.getValue()
      && 'value' in state.getValue().fieldData
    ))) {
    Object.defineProperty(result, 'value', {
      get() {
        let atom;
        let value;
        if (isValidForm(form)) {
          atom = form;
          value = form.getValue().content;
        } else if (state.getVal) {
          atom = state;
          value = atom.getVal();
        }
        return proxyValueTree(value, atom, value);
      },
      set(value) {
        if (isValidForm(form)) {
          form.setValue(value);
        } else if (state.setVal) {
          state.setVal(value);
        }
      },
      enumerable: true,
    });
  }
  proxyBehavior(result, state, form);
  return result;
}

export function isValidForm(form) {
  return form && form.items && form.items.length && (form instanceof Form);
}

const stateAPI = [
  'invokeValidate',
  'forceValid',
  'disableValid',
  'enableValid',
  'reset',
  'merge',
  'mergeVal',
  'push',
  'forceUpdate',
  'toJS',
  'saveResetPoint',
  'clear',
  'setValidation',
];

function proxyStateAPI(proxy, state, form) {
  stateAPI.forEach((api) => {
    if (isValidForm(form) && form[api]) {
      proxy[api] = form[api].bind(form);
    } else if (state[api]) {
      proxy[api] = state[api].bind(state);
    }
  });
  if (isValidForm(form)) {
    proxy.setData = form.setData.bind(form);
    proxy.setFieldData = form.setFieldData.bind(form);
  }
}
/* eslint-enable no-use-before-define */
// 代理scope
export function proxyScope({ ctx, scope, prop }) {
  const state = scope.get(prop);
  const form = scope.getForm(prop);
  if (!state || typeof state !== 'object') {
    if (isValidForm(form)) {
      return proxyOwnerForm(ctx, form, scope);
    }
  }
  return proxyStateWithForm({
    ctx, state, scope, form,
  });
}

/**
 * 代理父作用域
 * @param {object} ctx 渲染上下文
 */
export function proxyParent(ctx, scope) {
  let { owner } = scope;
  while (owner && (!owner.isRoot && !owner.componentSchema)) {
    ({ owner } = owner);
  }
  if (!owner.isRoot) {
    ({ owner } = owner);
  }
  return proxyCreateContext(ctx, owner);
}
